import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import SkeletonMenuLoader from "../../components/SkeletonMenuLoader";
import { getRestaurantMenuUICustomizations } from "../../../../../utilities/restaurantMenuCustomizationsUtil";
import {
    setRestaurantMenuUICustomizations,
    fetchAllRestaurantMenuData,
    getAllVoucherData,
} from "../../../../../../../redux/resturantWidgetSlice";
import "./VoucherV3.scss";
import backgroundImg from "../../assets/images/Images/voucher-bg.jpg"
import standard from "../../assets/standardVoucher.svg"
import cust from "../../assets/customVoucher.svg"
import RightCart from "../../components/Drawers/RightDrawerCart/RightCart";
import Modal from "../../components/Modal/Modal";
import LayoutVoucher from "./layouts-vouchers/LayoutVoucher";
import CustomVouchers from "./CustomVouchers/CustomVouchers";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { getTemplateData } from "../../../RestaurantWidget/utilities/api/voucherService";
import RightCartVoucher from "../../components/Drawers/RightDrawerCart/RightCartVoucher";
const VoucherV3 = ({ menu }) => {
    const dispatch = useDispatch();
    const standardRef = useRef(null)
    const customRef = useRef(null)

    const [checkoutFailed, setCheckoutFailed] = useState("");
    const [isCartAlertVisible, setCartAlertVisible] = useState(false)
    const { menuData: { isLoading }, defualtSelectedLocation, organizationID } = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [templateData, setTemplateData] = useState([])
    const [voucerData, setVoucherData] = useState([])
    const [menuData, setMenuData] = useState([])
    const [isOrderSuccess, setIsOrderSuccess] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isItemLoading, setIsItemLoading] = useState("");



    const restaurantDataState = useSelector((state) => state.resturantData);
    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;

    const [widgetState, setWidgetState] = useState({
        isPopup: null,
        layout: null,
        customizations: null,
        themeAvailable: false,
        isInitialLoading: true,
    });
    useEffect(() => {
        window.scrollTo(0, 0);
        localStorage.setItem("selected_cat", "vouchers")
    }, []);
    const initializeMenuCustomizations = useCallback(() => {
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        if (menu) {
            const menuData = JSON.parse(menu);
            const menuCustomizationValues = getRestaurantMenuUICustomizations(menuData);
            dispatch(setRestaurantMenuUICustomizations({ uiCustomizations: menuCustomizationValues }));
            setWidgetState((prevState) => ({
                ...prevState,
                customizations: menuData,
                isPopup: menuData?.selectedCard === 'popup',
                layout: menuData?.selectedLayout,
                themeAvailable: menuData?.selctedTheme !== "removeTheme",
            }));
        }
    }, [menu, dispatch]);

    const fetchMenuData = useCallback(() => {
        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: defualtSelectedLocation.CloudLocationID,
            OrganizationID: organizationID,
            Type: "VOUCHER",
        }));
        setWidgetState((prevState) => ({ ...prevState, isInitialLoading: false }));
    }, [dispatch, defualtSelectedLocation, organizationID]);

    useEffect(() => {
        initializeMenuCustomizations();
    }, [initializeMenuCustomizations]);

    useEffect(() => {
        fetchMenuData();
    }, [fetchMenuData]);
    useEffect(() => {
        getVouchersData()
        getData()
    }, []);
    const getVouchersData = async () => {
        let vouchers = await getAllVoucherData()
        if (vouchers) {
            setVoucherData(vouchers?.data)
            setMenuData(vouchers)
        }
    }
    const getData = async () => {
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        let valueDate = await getTemplateData(val.cloudLocationID)
        if (valueDate) {
            setTemplateData(valueDate)
        }
    }

    useEffect(() => {
        if (isLoading) {
            setWidgetState((prevState) => ({ ...prevState, isInitialLoading: true }));
        }
    }, [isLoading]);
    const getCartTotal = () => {
        return restaurantDataState?.orderDetails?.Payment?.
            PaymentDetail?.OrderTotal?.Gross?.Formatted ?? "£ 0.00"

    }
    const isStoreOpen = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.openingHours?.find(day => day.Day === currentDay);
        if (!today || today.Closed) return false;

        for (let hours of today.OpenHours) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    return (
        <div>
            <Modal visibility={checkoutFailed !== ""} type="failed" headerText="Sorry!" subText={checkoutFailed} onPopupClose={() => {
                setCheckoutFailed("")
            }} />
            <Modal visibility={isCartAlertVisible} type="failed" headerText="This voucher can’t be added!" subText={`Sorry, Vouchers and menu items can’t be added to the cart together.`} onPopupClose={() => {
                setCartAlertVisible(false)
            }} />
            <Modal visibility={isOrderSuccess} type="success"
                headerText="Voucher added to your cart!"
                subText="You can review your cart or proceed to checkout to complete your purchase."
                onPopupClose={() => {
                    setIsOrderSuccess(false)
                }}
            />
            {widgetState.isInitialLoading && isLoading ? (
                <SkeletonMenuLoader />
            ) : (

                isLoading ? (
                    <SkeletonMenuLoader />
                ) : (
                    <div className="VoucherV3">
                        <div className="VoucherV3-header"
                            style={{
                                backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)), url(${backgroundImg})`
                            }} >
                            <div className="VoucherV3-header-text1">Gift Your Way
                            </div>
                            <div className="VoucherV3-header-text2">Instantly Or Uniquely Yours!
                            </div>
                            <div className="VoucherV3-header-text3">Choose from our curated gift vouchers or create your own
                            </div>
                            <div className="VoucherV3-header-btnCont">
                                <div className="VoucherV3-header-btnCont-stndrd"
                                    onClick={() => {
                                        const yOffset = -100;
                                        const y =
                                            standardRef.current.getBoundingClientRect().top +
                                            window.pageYOffset +
                                            yOffset;

                                        window.scrollTo({ top: y, behavior: "smooth" });
                                    }}>

                                    <img alt="" src={standard} />Standard Vouchers</div>
                                <div className="VoucherV3-header-btnCont-cust"
                                    onClick={() => {
                                        const yOffset = -100;
                                        const y =
                                            customRef.current.getBoundingClientRect().top +
                                            window.pageYOffset +
                                            yOffset;

                                        window.scrollTo({ top: y, behavior: "smooth" });
                                    }}>
                                    <img alt="" src={cust} />Custom Vouchers</div>
                            </div>
                        </div>
                        <div className="VoucherV3-styles">
                            <div className="VoucherV3-styles-inner">

                                <div className="VoucherV3-styles-inner-left">
                                    <div className="VoucherV3-Standard" ref={standardRef}>
                                        <div className="VoucherV3-Standard-header">Standard Vouchers
                                        </div>
                                        <div className="VoucherV3-Standard-subheader">Ready-to-gift vouchers in popular denominations. Perfect for any occasion.
                                        </div>
                                        <LayoutVoucher
                                            data={voucerData}
                                            setCartAlertVisible={setCartAlertVisible}
                                            menuData={menuData}
                                            setIsOrderSuccess={setIsOrderSuccess}
                                            setIsItemLoading={setIsItemLoading} />
                                    </div>
                                    <div className="VoucherV3-Custom" ref={customRef}>
                                        <div className="VoucherV3-Custom-header">Custom Vouchers
                                        </div>
                                        <div className="VoucherV3-Custom-subheader">Create personalized vouchers with your own message and design
                                        </div>
                                        <div className="VoucherV3-Custom-container">
                                            <CustomVouchers
                                                Data={templateData}
                                                setCartAlertVisible={setCartAlertVisible}
                                                visibility={true}
                                                setIsOrderSuccess={setIsOrderSuccess} />
                                        </div>
                                    </div>
                                </div>
                                <div className="VoucherV3-styles-inner-right">
                                    <RightCartVoucher
                                        isStoreOpen={isStoreOpen}
                                        setCheckoutFailed={setCheckoutFailed}
                                        setIsStoreClosed={() => { }}
                                        setIsStoreOrderBlocked={() => { }}
                                        setIsScheduleError={() => { }}
                                        setIsScheduleTimeError={() => { }}
                                        isMobile={false}
                                        isOpen={true}
                                        setIsOpen={() => { }}
                                        suggestedItems={[]}
                                        isItemLoading={isItemLoading}


                                    />
                                </div>
                            </div>
                            {isOpen && <div className="VoucherV3-styles-cart">
                                <RightCartVoucher
                                    isStoreOpen={isStoreOpen}
                                    setCheckoutFailed={setCheckoutFailed}
                                    setIsStoreClosed={() => { }}
                                    setIsStoreOrderBlocked={() => { }}
                                    setIsScheduleError={() => { }}
                                    setIsScheduleTimeError={() => { }}
                                    isMobile={true}
                                    isOpen={isOpen}
                                    setIsOpen={setIsOpen}
                                    suggestedItems={[]}
                                    isItemLoading={isItemLoading}

                                />
                            </div>}
                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.length > 0 && !isOpen &&
                                < div className="mobilecart-fix">
                                    <div className="mobilecart-fix-inner"
                                        onClick={() => {
                                            setIsOpen(true)
                                        }}>
                                        <div className="mobilecart-fix-inner-item1">{restaurantDataState.orderCartData.Items.length}</div>
                                        <div className="mobilecart-fix-inner-item2">Next: View Order</div>
                                        <div className="mobilecart-fix-inner-item3">{getCartTotal()}</div>
                                    </div>
                                </div>}
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default VoucherV3;
